import React from "react";
import styles from "./CheckListComponent.module.css";
import InlinePointsComponent from "../InlinePointsComponent/InlinePointsComponent";
import TextComponent from "../textComponent/TextComponent";

const CheckListComponent = (props) => {
  return (
    <div className={styles.OptionsContainer}>
      <div  className={styles.HeadingDiv} >
        <TextComponent text={props?.Heading} className={styles.Heading} />
      </div>
      <div className={styles.OptionsList}>
        {props?.Options?.map((item) => {
          return (
            <div>
              <InlinePointsComponent description={item?.title} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckListComponent;
